import { DateRange } from './date';

export class System {
        displayName: string;
        appCode: string;
        system:string;
        description: string;
        name: string;
}

export class SystemSearch {
    createdDate: DateRange = DateRange.empty();
    displayName = '';
    name = '';
    appCode = '';
    system = '';
    description = '';
    id='';
 }